import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Button, Box } from "@mui/material";
import GoalItem from "./GoalItem";
import {
  themeStyles,
  buttonStyle,
  getColorForGoalState,
} from "../../constants";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery, Grid, Typography } from "@mui/material";
import useSharedLink from "../../scenes/SharedLink";
import axiosInstance from "../../components/AxiosInstance";
const GoalDataCollectionManager = ({
  client,
  nodes,
  clientId,
  clientName,
  dataCollectionType,
  sessionId,
  owner,
  goalSelected = null,
  dateSelected = null,
}) => {
  // Initialize selectedDate with sessionDate
  console.log(
    "goalselected id in goaldatacollectionmanager",
    goalSelected,
    dateSelected
  );
  const sharedLink = useSharedLink();
  const [selectedGoal, setSelectedGoal] = useState(
    goalSelected
      ? (nodes || []).map((node) => node.goalId === goalSelected)
      : null
  );
  const [highlightedGoals, setHighlightedGoals] = useState([]);
  const [goalDataReady, setGoalDataReady] = useState(false);
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(
    dayjs(dateSelected).isValid() ? dayjs(dateSelected) : dayjs()
  );

  const [rerenderKey, setRerenderKey] = useState(0); // Replaced goclick with rerenderKey for clarity
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleGoalChange = (event, newValue) => {
    setSelectedGoal(newValue);
    setGoalDataReady(false);
    setRerenderKey(rerenderKey + 1);
  };

  const handleGoClick = () => {
    if (selectedGoal && selectedDate) {
      setGoalDataReady(true);
      setRerenderKey((prevKey) => prevKey + 1); // Increment rerenderKey to force re-render
    }
  };
  const fetchHighlightedGoals = async (date) => {
    try {
      const payload = {
        clientId: clientId,
        sessionDate: dayjs(date).format("YYYY-MM-DD"),
      };
      const response = await axiosInstance.post(
        `${sharedLink}/getRawDataColor`,
        payload
      );

      if (response.status === 200) {
        const goalIdsToHighlight = [
          ...(response.data.percentageData || []),
          ...(response.data.taskAnalysisData || []),
          ...(response.data.durationData || []),
        ];
        setHighlightedGoals(goalIdsToHighlight);
      }
    } catch (error) {
      console.error("Failed to fetch highlighted goals:", error);
    }
  };

  useEffect(() => {
    fetchHighlightedGoals(selectedDate);
  }, [selectedDate]);
  // This useEffect is unnecessary unless you have more logic to include in it
  useEffect(() => {
    const select = (nodes || []).map(
      (node) => node.goalId + "" === "" + goalSelected
    );
    console.log(
      "selected date in useeffect",
      selectedDate,
      selectedGoal,
      goalSelected,
      dateSelected,
      select
    );
    setSelectedDate(
      dayjs(dateSelected).isValid() ? dayjs(dateSelected) : dayjs()
    );

    setSelectedGoal(
      goalSelected
        ? (nodes || []).find((node) => node.goalId + "" === "" + goalSelected)
        : selectedGoal
    );
  }, [goalSelected, dateSelected]);

  return (
    <Box
      key={selectedDate || selectedGoal}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        width: "100%",
        mt: 2,
        mb: 2,
      }}>
      <Grid container spacing={2} sx={{ width: "80%" }}>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            options={nodes.filter(
              (node) => node.programType?.toLowerCase() !== "frequency"
            )}
            value={selectedGoal}
            getOptionLabel={(option) => option.goalName || "Unnamed Goal"}
            onChange={handleGoalChange}
            renderOption={(props, option) => {
              const isHighlighted = highlightedGoals.find(
                (highlight) => highlight.goalId === option.goalId
              );
              const goalState = isHighlighted
                ? isHighlighted.goalState || option.goalState || "Baseline"
                : "Baseline";
              console.log("ishighlighted", isHighlighted);
              return (
                <Box
                  {...props}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 12px",
                    margin: "4px 0",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    backgroundColor:
                      isHighlighted && isHighlighted?.nullExists === false
                        ? "#d0f0c0" // Light green background for highlighted goals
                        : selectedGoal && selectedGoal.goalId === option.goalId
                        ? "skyblue" // Sky-blue background for the selected goal
                        : "#fff",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                  }}>
                  <Typography
                    variant="body1"
                    sx={{
                      flexGrow: 1,
                      textAlign: "left",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}>
                    {option.goalName}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      color: getColorForGoalState(goalState),
                      textAlign: "right",
                      fontSize: "14px",
                      minWidth: "100px",
                    }}>
                    {goalState}
                  </Typography>
                </Box>
              );
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select Goal" variant="outlined" />
            )}
            sx={{
              width: "100%",
              mt: 2,
              "& .MuiAutocomplete-inputRoot": { padding: "6px" },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DatePicker
            type="date"
            label="Select Date"
            value={dayjs(selectedDate).isValid() ? selectedDate : dayjs()} // Fallback to today
            onChange={(newValue) => {
              setSelectedDate(newValue);
              setRerenderKey(rerenderKey + 1);
            }}
            disableFuture
            sx={{ width: "100%", ...themeStyles.textField }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            variant="contained"
            onClick={handleGoClick}
            disabled={!selectedGoal || !selectedDate}
            sx={{ width: "100%", ...buttonStyle }}>
            Go
          </Button>
        </Grid>
      </Grid>
      {goalDataReady && selectedGoal && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "80%",
            mt: 2,
          }}>
          <GoalItem
            client={client}
            key={selectedDate || selectedGoal}
            goal={selectedGoal}
            clientId={clientId}
            clientName={clientName}
            goals={nodes}
            dataCollectionType={dataCollectionType}
            sessionId={sessionId}
            sessionDate={selectedDate}
            owner={owner}
            highlightedGoals={highlightedGoals}
            setHighlightedGoals={setHighlightedGoals}
          />
        </Box>
      )}
    </Box>
  );
};

export default GoalDataCollectionManager;
